import { route, tag, type PageTour } from '../pageTour';

export const heatmapTour: PageTour = {
  id: 'page-heatmap',
  version: 1,
  title: 'Heatmap',
  summary: 'Where activity concentrates in a camera view over time.',
  // `/reports/heatmap` must be listed before the generic `/reports/:model` tour.
  match: route('/reports/heatmap', '/nodes/:nodeId/cameras/:cameraId/heatmap'),
  steps: [
    {
      target: tag('heatmap-range'),
      title: 'Time range',
      description: 'Pick the period the heatmap covers. Auto refresh keeps it up to date every 30 seconds.',
      side: 'bottom',
    },
    {
      target: tag('heatmap-view'),
      title: 'Heatmap over live view',
      description: 'Activity is drawn on top of the camera\'s live feed — warmer colours mark where people spent the most time.',
      side: 'right',
    },
    {
      target: tag('heatmap-layers'),
      title: 'Display options',
      description: 'Turn the heatmap or grid on and off, and set how see-through the overlay is.',
      side: 'bottom',
    },
    {
      target: tag('heatmap-stats'),
      title: 'Activity figures',
      description: 'Totals for the selected camera over the chosen period. Hits count activity, not people.',
      side: 'top',
    },
    {
      target: tag('heatmap-cameras'),
      title: 'Reporting cameras',
      description: 'Cameras with heatmap data, busiest first. Select one to show its heatmap.',
      side: 'left',
    },
  ],
};
